import { Component, OnInit } from '@angular/core';
import { FormSuggesetionsService } from '../services/form-suggestions/form-suggestions.service';
import { FormBuilderService } from '../services/form-builder/form-builder.service';
import { FlyoutService } from '@yourcause/common/flyout';
import { map } from 'rxjs';
import { SpellCheckCorrectionForUi } from '../form-builder.typing';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'gc-form-suggestions-flyout',
  templateUrl: './form-suggestions-flyout.component.html',
  styleUrls: ['./form-suggestions-flyout.component.scss']
})
export class FormSuggestionsFlyoutComponent implements OnInit {
  formId = this.formBuilderService.currentFormBuilderFormId;
  $numberOfSuggestions = this.formSuggestionsService.changesTo$('formSuggestions').pipe(
    map((suggestions) => {
      return '' + suggestions.length;
    })
  );
  suggestions: SpellCheckCorrectionForUi[] = [];
  selections: SpellCheckCorrectionForUi[] = [];
  selectedSuggestionIndex: number;

  constructor (
    private formSuggestionsService: FormSuggesetionsService,
    private formBuilderService: FormBuilderService,
    private flyoutService: FlyoutService
  ) { }

  ngOnInit () {
    this.suggestions = cloneDeep(this.formSuggestionsService.formSuggestions);
    this.setSelections();
  }

  setSelections () {
    this.selections = this.suggestions.filter((suggestion) => {
      return suggestion.selected;
    });
  }

  onSelectionChange () {
    this.setSelections();
  }

  onCancel () {
    this.flyoutService.closeFlyout();
  }

  onSelectAll () {
    this.suggestions.forEach((suggestion) => {
      suggestion.selected = true;
    });
    this.setSelections();
  }

  onUnselectAll () {
    this.suggestions.forEach((suggestion) => {
      suggestion.selected = false;
    });
    this.setSelections();
  }

  goToComponent (suggestion: SpellCheckCorrectionForUi, index: number) {
    this.formSuggestionsService.setSelectedComponent(suggestion.component);
    this.selectedSuggestionIndex = index;
  }


  onApplyChanges () {
    this.formSuggestionsService.applyChanges(this.selections);
  }
}

